import { DecimalField, Form } from '@ff-it/form';
import { Button, PopoverRoot, PopoverTrigger, PopoverPopup, createPopoverHandle, Stack } from '@ff-it/ui';
import { ReactElement, useState } from 'react';
import { required } from 'utilities';

type SeekButtonProps = {
  seekBudgetQuantity: (values: { budget: string }) => void;
};

export function SeekButton({ seekBudgetQuantity }: SeekButtonProps): ReactElement {
  const [handle] = useState(() => createPopoverHandle());
  return (
    <PopoverRoot handle={handle}>
      <PopoverTrigger>
        <Button variant="ghost" icon="bullseye-arrow" size="xs" testId="goal-seek" />
      </PopoverTrigger>
      <PopoverPopup placement="bottom-start">
        <Form<{ budget: string }>
          onSubmit={(values) => {
            seekBudgetQuantity(values);
            handle.close();
          }}
          autoComplete="off"
        >
          <Stack direction="horizontal" p="2">
            <DecimalField name="budget" placeholder="Budget" required validate={required} className="mb-0" />
            <Button type="submit" testId="goal-seek-submit">
              Goal seek qauntity
            </Button>
          </Stack>
        </Form>
      </PopoverPopup>
    </PopoverRoot>
  );
}
